import moment from 'moment';
import { IonInput } from '@ionic/react';
import { PickerWrapper } from '../picker/PickerWrapper';
import { DateTimePicker } from '../picker/DateTimePicker';
import { FieldInputProps } from './Field';

export interface TimeInputProps extends FieldInputProps {
    value: string;
    onChange?: (value: string) => void;
}

export const TimeInput: React.FC<TimeInputProps> = ({ readonly, value, onChange }) => {

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const handleChange = (dateTime: string) => {
        if (onChange && !readonly) {
            onChange(moment(dateTime).toISOString());
        }
    };

    return (
        <div style={{marginTop: 5, marginBottom: -5}}>

            {/* dummy IonInput value forces Field wrapper label to be stacked */}
            <IonInput value="dummy" style={{display: 'none'}}/>

            <PickerWrapper>
                <DateTimePicker disabled={readonly} dateTime={value} timezone={timezone} onChange={handleChange} />
            </PickerWrapper>

        </div>
    );
};
